import { z } from "zod";
import { ColorTokenData } from "./color";
import { BorderWidthTokenData } from "./border-width";
import { tokenAliasOrValue } from "./base";

export const BorderPosition = z.enum(["Inside", "Center", "Outside"]);
export const BorderStyle = z.enum(["Dashed", "Dotted", "Solid", "Groove"]);

export const BorderValue = z.object({
  color: ColorTokenData,
  width: BorderWidthTokenData,
  position: BorderPosition,
  style: BorderStyle.optional(),
});

export const BorderTokenData = tokenAliasOrValue(BorderValue);

export type BorderPosition = z.infer<typeof BorderPosition>;
export type BorderStyle = z.infer<typeof BorderStyle>;
export type BorderValue = z.infer<typeof BorderValue>;
export type BorderTokenData = z.infer<typeof BorderTokenData>;
